import { api } from '@goaltree/backend/convex/_generated/api'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useAction } from 'convex/react'
import { useEffect, useRef } from 'react'

// Fitbit/Strava redirect here. Native connects come back through the app scheme.
export const Route = createFileRoute('/api/fitness/callback')({
  validateSearch: (search): { code?: string; state?: string; error?: string } => ({
    code: typeof search.code === 'string' ? search.code : undefined,
    state: typeof search.state === 'string' ? search.state : undefined,
    error: typeof search.error === 'string' ? search.error : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { code, state, error } = Route.useSearch()
  const complete = useAction(api.fitness.completeConnection)
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true
    const done = (ok: boolean, client?: 'web' | 'native') => {
      const result = ok ? 'connected' : 'error'
      if (client === 'native') {
        window.location.href = `goaltree://settings?fitness=${result}`
        return
      }
      navigate({ to: '/settings', search: { fitness: result }, hash: 'apps', replace: true })
    }
    if (error || !code || !state) {
      done(false)
      return
    }
    complete({ code, state })
      .then((r) => done(r.ok, r.client))
      .catch(() => done(false))
  }, [code, state, error, complete, navigate])

  return (
    <div className="flex h-dvh items-center justify-center text-sm text-muted-foreground">
      Connecting…
    </div>
  )
}
